<!-- ProjectInfo.vue - "Über SmoothRide": posts from PocketBase in the article layout. Section ids are the post slugs
     (the submit form links to #terms and #data-protection). -->
<template>
  <ArticleLayout
    :eyebrow="$t('legal.aboutEyebrow')"
    :title="$t('meta.about.title')"
    :lead="$t('meta.about.description')"
    :sections="records.map((r) => ({ id: r.slug, title: r.title }))"
  >
    <p v-if="loading" role="status">…</p>
    <section v-for="record in records" :id="record.slug" :key="record.id">
      <h2>{{ record.title }}</h2>
      <!-- Post content is written by the site admin in PocketBase -->
      <div class="post" v-html="record.content"></div>
    </section>
  </ArticleLayout>
</template>

<script>
import ArticleLayout from '@/components/ArticleLayout.vue';

export default {
  name: 'ProjectInfo',
  components: { ArticleLayout },
  data() {
    return { records: [], loading: true };
  },
  async created() {
    try {
      const data = await this.$pb.collection('posts').getList(1, 50, { sort: '-updated' });
      this.records = data.items;
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.post :deep(img) { max-width: 100%; height: auto; border-radius: var(--radius-lg); }
.post :deep(ul), .post :deep(ol) { padding-left: 20px; }
</style>
